import React, {PropTypes} from "react";
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class NavItems extends React.Component {
  static propTypes = {
    lang: PropTypes.string,
    mode: PropTypes.string,
    onClick: PropTypes.func,
    restaurant: PropTypes.string,
    view: PropTypes.string,
    wine_slug: PropTypes.string,
    package: PropTypes.number
  };

  render() {
    return (
      <nav className="main-nav">
        <ul>
          <li>
            <Link className={'nav-link nav-home' + (this.props.view === 'home' ? ' active' : '')}
                  to={'/' + this.props.lang + '/' + this.props.restaurant}>
              <FormattedMessage id="nav_home">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </Link>
          </li>
          <li>
            <Link className={'nav-link nav-menu' + (this.props.view === 'menu' ? ' active' : '')}
                  to={'/' + this.props.lang + '/' + this.props.restaurant + '/menu'}>
              <FormattedMessage id="nav_menu">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </Link>
          </li>
          {this.props.package === 1 && this.props.wine_slug ?
            (<li>
              <Link className={'nav-link nav-wines' + (this.props.view === 'wines' ? ' active' : '')}
                    to={'/' + this.props.lang + '/' + this.props.restaurant + this.props.wine_slug}>
                <FormattedMessage id="nav_wines">
                  {(message) => <span>{message}</span>}
                </FormattedMessage>
              </Link>
            </li>) : null
          }

          <li>
            <Link className={'nav-link nav-suggestions' + (this.props.view === 'featured' ? ' active' : '')}
                  to={'/' + this.props.lang + '/' + this.props.restaurant + '/items/featured/'}>
              <FormattedMessage id="nav_suggestions">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </Link>
          </li>
          <li>
            <Link className={'nav-link nav-shortlist' + (this.props.view === 'shortlist' ? ' active' : '')}
                  to={'/' + this.props.lang + '/' + this.props.restaurant + '/items/shortlist'}>
              {cookies.get('favsTotal') > 0 ?
                <sup>{cookies.get('favsTotal')}</sup>
                : null
              }
              <span>myPick</span>
            </Link>
          </li>
          <li>
            <Link className={'nav-link nav-about' + (this.props.view === 'about' ? ' active' : '')}
                  to={'/' + this.props.lang + '/' + this.props.restaurant + '/about'}>
              <FormattedMessage id="nav_about">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </Link>
          </li>
          <li>
            <Link className={'nav-link nav-events' + (this.props.view === 'events' ? ' active' : '')}
                  to={'/' + this.props.lang + '/' + this.props.restaurant + '/events'}>
              <FormattedMessage id="nav_events">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </Link>
          </li>
          {
            this.props.mode !== 'kiosk' ?
              <li><Link className={'nav-link nav-feedback' + (this.props.view === 'feedback' ? ' active' : '')}
                        to={'/' + this.props.lang + '/' + this.props.restaurant + '/restaurant-feedback/'}>
                <FormattedMessage id="nav-feedback">
                  {(message) => <span>{message}</span>}
                </FormattedMessage>
              </Link></li>
              : null
          }
          {/* <li>
            <Link className={'nav-link nav-pickly' + (this.props.view === 'pickly' ? ' active' : '')}
                  to={'/' + this.props.lang + '/' + this.props.restaurant + '/pickly'}>
              <FormattedMessage id="nav-pickly">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </Link>
          </li> */}
        </ul>
      </nav>

    );
  }
}


export default NavItems;



/** WEBPACK FOOTER **
 ** ./src/components/nav/NavItems.js
 **/